import { Box, styled } from '@mui/material';

// Único bloque con scroll del panel (`minHeight: 0` para que el flex lo deje encogerse).
const StyledNotificationList = styled(Box)(({ theme }) => ({
  flex: 1,
  listStyle: 'none',
  margin: 0,
  minHeight: 0,
  overflowY: 'auto',
  padding: 0,
  '&::-webkit-scrollbar': {
    width: 6
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.scrollbar.thumb,
    borderRadius: 999
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.scrollbar.thumbHover
  }
}));

export default StyledNotificationList;
